import { Hdc1Dot0MembershipResponse } from "../../../types/responses";

export function getHdc1Dot0Membership(
  partialResponse: Partial<Hdc1Dot0MembershipResponse> = {}
): Hdc1Dot0MembershipResponse {
  return {
    EffectiveDate: "2021-01-20",
    ExpirationDate: "2022-04-27",
    ProductCode: "USMEMB1",
    membershipID: "1",
    ...partialResponse,
  };
}
